export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5351.c1a65f2c.jpg";